import axios from 'axios'

export function getEventTutors(eventId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/events/' + eventId + '/-actions/get-tutors',  {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}

export function getEvents(spaceID, page, size) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceID + '/events?page[size]=' + size + '&page[number]=' + page, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}


export function getEventAttendees(eventId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/events/' + eventId + '/-actions/get-attendees', {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}

export function updateAttendees(eventId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/events/' + eventId + '/-actions/update-attendees', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}
